import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { IPlanSummaryLecturer, IPlanSummaryRotation } from '../../../models/PlanSummary';
import { AppService } from '../../../services/app.service';
import { PlanSummaryService } from '../../../services/plan-summary.service';
import { ICurrentRequest, getCurrentRequest } from '../plan-summary.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-plan-summary-remove-lecturer',
    templateUrl: './plan-summary-remove-lecturer.component.html'
})
export class PlanSummaryRemoveLecturerComponent implements OnInit, OnDestroy {
    constructor(
        public app: AppService,
        private service: PlanSummaryService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set rotation(value: IPlanSummaryRotation) {
        this._rotation = value;

        if (value.Lecturers.length == 1) {
            this.selected = value.Lecturers[0];
        }
    }

    get rotation() {
        return this._rotation;
    }

    selected: IPlanSummaryLecturer;
    isSaving: boolean;

    readonly displayFn = (item: IPlanSummaryLecturer) => item ? `${item.Name} ${item.Surname}` : '';

    private _rotation: IPlanSummaryRotation;
    private request: ICurrentRequest;
    private requestSub: Subscription;

    ngOnInit() {
        this.requestSub = getCurrentRequest().subscribe(req => {
            this.request = req;
        });
    }

    ngOnDestroy() {
        this.requestSub?.unsubscribe();
    }

    submit() {
        this.isSaving = true;

        this.app.addLoading(this.service.removeLecturer(this.selected.Id, this.selected.Name, this.selected.Surname, this.rotation.Id, this.request.params), 500)
            .pipe(finalize(() => this.isSaving = false)).subscribe(() => {
                this.activeModal.close();
            });
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
